import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
// Services
import { getField, getTable } from '../../../../Services/tooltipService';
import { get, update, getCustomerDetails, saveCRDScoreBox } from '../../../../Services/clientService';
import _ from 'lodash';
import socket from '../../../../socket';
import Summary from './Summary';
import Project from './project';
import EsgPreviewScore from './ESGPreview/esgPreviewScore';
import Programme from './programme';
// import EsgPreviewScore from './esgPreviewScore';
import Address from './Address&Contact/address';
import LinkStakeholder from './linkStakeholder';
import StakeHolderPlan from './StakeholderPlan';
import Loader from '../../../../Components/UiComponents/Loader';
import { getModulePermissions } from '../../../../Services/pricingPlanService';
import { useStakeholder } from '../../../../Providers/StakeholderContext';
import { pendingCliNotifications, reThrowNotification } from '../../../../Services/notificationService';
import { InputIcon } from 'primereact/inputicon';
import TabElement from '../../../../Components/UiComponents/TabElement';
import useScrollToTop from '../../../../Components/UiComponents/useScrollToTop';
import { useSidebar } from '../../../../Providers/SidebarContext';
import { useIsEdited } from '../../../../Providers/IsEditedProvider';
import { userPrivilleges } from '../../../../Services/userService';

export default function ClientEdit(props) {
    const { clientId, version } = useParams();
    const [customerId, setCustomerId] = useState(null);
    const toastRef = useRef();
    const [fieldData, setFieldData] = useState();
    const [tableData, setTableData] = useState();
    const { setIsEdited } = useIsEdited();
    const [items, setItems] = useState();
    const [clientFieldsNew, setClientFieldsNew] = useState();
    const [clientSectionsNew, setClientSectionsNew] = useState({});
    const [clientData, setClientData] = useState();
    const { targetRef, scrollToTop } = useScrollToTop();
    const [clientFieldsSummary, setClientFieldsSummary] = useState();
    const [clientSectionsSummary, setclientSectionsSummary] = useState({});
    const [clientSummaryTab, setClientSummaryTab] = useState();
    const [projectFieldsSummary, setprojectFieldsSummary] = useState();
    const [projectFieldsNew, setprojectFieldsNew] = useState();
    const [frameworkFieldsNew, setFrameworkFieldsNew] = useState();
    const [frameworkFieldsSummary, setFrameworkFieldsSummary] = useState();

    const [commonFields, setCommonFields] = useState();

    const [clientFieldsFramework, setClientFieldsFramework] = useState();
    const [clientSectionsFramework, setClientSectionsFramework] = useState({});
    const [clientFrameworkTab, setClientFrameworkTab] = useState();

    const [stakeholderLinkTab, setStakeholderLinkTab] = useState();
    const [clientFieldsLinkStakeholder, setClientFieldsLinkStakeholder] = useState();
    const [clientSectionsLinkStakeholder, setClientSectionsLinkStakeholder] = useState();

    const [clientFieldsClientPlan, setClientFieldsClientPlan] = useState();
    const [clientSectionsClientPlan, setClientSectionsClientPlan] = useState({});
    const [clientClientPlanTab, setClientClientPlanTab] = useState();

    const [clientFieldsProject, setClientFieldsProject] = useState();
    const [clientSectionsProject, setClientSectionsProject] = useState({});
    const [clientProjectTab, setClientProjectTab] = useState();

    const [clientFieldsRDS, setClientFieldsRDS] = useState();
    const [clientSectionsRDS, setClientSectionsRDS] = useState({});
    const [clientRDSTab, setClientRDSTab] = useState();

    const [clientFieldsAC, setClientFieldsAC] = useState();
    const [clientSectionsAC, setClientSectionsAC] = useState({});
    const [clientACTab, setClientACTab] = useState();
    const [activeIndex, setActiveIndex] = useState(0);
    const [branch, setBranch] = useState(null);

    const [customerDetails, setCustomerDetails] = useState({});
    const [clientPlanTable, setClientPlanTable] = useState({});
    const [clientKnownHeading, setClientKnownHeading] = useState({});
    const [clientAssociatedFrame, setClientAssociatedFrame] = useState({});
    const [clientAssociatedStakeholderFrame, setClientAssociatedStakeholderFrame] = useState({});
    const [clientKnownHeaders, setClientKnownHeaders] = useState({});
    const [clientNeedsHeading, setClientNeedsHeading] = useState({});
    const [clientObjectivesHeading, setClientObjectivesHeading] = useState({});
    const [clientDocumentHeading, setClientDocumentHeading] = useState({});
    const [rdsValue, setRdsValue] = useState({});
    const [addressContactFields, setAddressContactFields] = useState();
    const [rdsTotal, setRdsTotal] = useState();
    const [loading, setLoading] = useState(false);
    const [pricingPlan, setPricingPlan] = useState('');
    const [tabPermissions, setTabPermissions] = useState({});
    const [open, setopen] = useState(true);
    const [newItems, setNewItems] = useState([]);
    const navigate = useNavigate()
    const [appRestrictedTabs, setAppRestrictedTabs] = useState([]);
    const [restrictedUserTabs, setRestrictedUserTabs] = useState([]);
    const [enableTabs, setEnableTabs] = useState({});


    const { globalStakeholderData, setGlobalStakeholderData } = useStakeholder();
    const { globalSidebarData } = useSidebar();

    let location = useLocation();

    useEffect(() => {
        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);

            // Extracting customer information from end user data
            const customer = enduser.customer;

            // Setting customer ID state
            setCustomerId(customer);
            const branch = enduser.branch;
            // Setting customer ID state
            setBranch(branch);
        } else {
            navigate("/login")
            localStorage.clear()
          }

    }, []);

    // useEffect(() => {
    //     setGlobalStakeholderData(clientData);
    // }, [clientData]);

    useEffect(() => {
        if (customerId) {
            getFieldData();
            getCustomerDetail();
            getTableData();
        }
    }, [customerId]);

    useEffect(() => {
        if (customerDetails) {
            enablingTabs();
            getModulePermission()
        }
    }, [customerDetails,appRestrictedTabs, restrictedUserTabs])

    const enablingTabs = () => {
        var enableTab = {};
        var userPrivillege = userPrivilleges();

        if (userPrivillege && userPrivillege.isRestricted) {
          for (let tab of appRestrictedTabs) {
            for (let rest of restrictedUserTabs) {

              if (rest.label === tab.label) {
                enableTab[tab.label] = true;
              }
            }
          }
          //For extra tab (save image icon)
          enableTab["save image"] = true;
        } else {
          for (let tab of appRestrictedTabs) {

            enableTab[tab.label] = true;
          }
          //For extra tab (save image icon)
          enableTab["save image"] = true;
        }

        setEnableTabs(enableTab);
      };

    const getModulePermission = async () => {
        try {
          // Check if the pricing plan is defined
          if (pricingPlan) {
            // Fetch module permissions based on the pricing plan
            const res = await getModulePermissions(pricingPlan, "Clients");
      
            // Check if response data exists
            if (res &&res.data) {
              const modulePermissions = res.data;
      
              // Check if the status is true
              if (modulePermissions.status) {
                const tabPermissions = {};
      
                // Use lodash filter to create tab permissions from sub_modules
                _.filter(modulePermissions.sub_modules, (sub_module) => {
                  tabPermissions[sub_module.module_name] = sub_module.status;
                });
      
                // Update state with the new tab permissions
                setTabPermissions(tabPermissions);
              }
            }
          }
        } catch (error) {
          // Handle any errors that occur during the API call
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch module permissions. Please try again or contact Admin.",
          });
        }
      };
      

    const getCustomerDetail = async () => {
        try {
            setLoading(true); 
    
            // Fetch customer details
            const response = await getCustomerDetails(customerId);
            
            // Set the customer details and pricing plan
            setCustomerDetails(response);
            setPricingPlan(response.data.pricing_plan);
            setAppRestrictedTabs(response.data.application_stakeholder_tabs);
            setRestrictedUserTabs(response.data.restricted_stakeholder_tabs);
        } catch (error) {
            // Handle any errors that occur during the API call
            toastRef.current.showToast({
                type: "error",
                message: "Failed to fetch customer details. Please try again or contact Admin."
            });
        } finally {
            setLoading(false); 
        }
    };
    
    const getData = (data) => {
        setClientData(data)
    }

    const getEsgData = (data) => {
        setClientData(data)
    }

    const getTotalValue = (data) => {
        setRdsTotal(data)
    }
    const getProgramme = (data) => {
        setClientData(data)
    }


    useEffect(() => {
        setLoading(true)
        const tabs = [
            {
                label: clientSummaryTab,
                icon: 'pi pi-list',
                Component: <Summary
                    customerId={customerId}
                    clientId={clientId}
                    getData={getData}
                    summaryData={{
                        "clientFieldsSummary": clientFieldsSummary,
                        "clientSectionsSummary": clientSectionsSummary,
                        "clientSummaryTab": clientSummaryTab,
                        "clientFieldsNew": clientFieldsNew,
                        "commonFields": commonFields,
                    }} />
            },
            {
                label: clientFrameworkTab,
                icon: 'pi pi-briefcase',
                Component: <Programme
                    customerId={customerId}
                    getProgramme={getProgramme}
                    branch={branch}
                    getData={getData}
                    clientId={clientId}
                    customerDetails = {customerDetails}
                    frameworkData={{
                        "clientFieldsFramework": clientFieldsFramework,
                        "clientSectionsFramework": clientSectionsFramework,
                        "clientFrameworkTab": clientFrameworkTab,
                        "frameworkFieldsSummary": frameworkFieldsSummary,
                        "clientFieldsNew": clientFieldsNew,
                        "frameworkFieldsNew": frameworkFieldsNew,
                        "commonFields": commonFields,
                        "clientAssociatedFrame": clientAssociatedFrame
                    }} />
            },
            {
                label: clientProjectTab,
                icon: 'pi pi-file',
                Component: <Project
                    customerId={customerId}
                    clientId={clientId}
                    customerDetails={customerDetails}
                    projectData={{
                        "clientFieldsProject": clientFieldsProject,
                        "clientSectionsProject": clientSectionsProject,
                        "clientProjectTab": clientProjectTab,
                        "projectFieldsSummary": projectFieldsSummary,
                        "clientFieldsNew": clientFieldsNew,
                        "projectFieldsNew": projectFieldsNew,
                        "commonFields": commonFields,
                    }} />
            },
            {
                label: clientRDSTab,
                icon: 'pi pi-star',
                Component: <EsgPreviewScore
                    customerId={customerId}
                    getEsgData={getEsgData}
                    clientData={clientData}
                    getTotalValue={getTotalValue}
                    clientId={clientId}
                    setClientData={setClientData}

                    EsgPreviewScoreData={{
                        "clientFieldsRDS": clientFieldsRDS,
                        "clientSectionsSummary": clientSectionsRDS,
                        "clientSummaryTab": clientRDSTab,
                        "clientFieldsNew": clientFieldsNew,
                        "commonFields": commonFields,
                    }} />
            },
            {
                label: clientClientPlanTab,
                icon: 'pi pi-desktop',
                Component: <StakeHolderPlan
                    customerId={customerId}
                    clientId={clientId}
                    getData={getData}
                    clientPlanData={{
                        "clientFieldsClientPlan": clientFieldsClientPlan,
                        "clientSectionsClientPlan": clientSectionsClientPlan,
                        "clientKnownHeading": clientKnownHeading,
                        "clientKnownHeaders": clientKnownHeaders,
                        "clientPlanTable": clientPlanTable
                    }} />
            },
            {
                label: stakeholderLinkTab,
                icon: 'pi pi-map',
                Component: <LinkStakeholder
                    customerId={customerId}
                    getData={getData}
                    clientId={clientId}
                    branch={branch}
                    linkStakeholderData={{
                        "clientFieldsLinkStakeholder": clientFieldsLinkStakeholder,
                        "clientSectionsLinkStakeholder": clientSectionsLinkStakeholder,
                        "clientSectionsProject": clientSectionsProject,
                        "stakeholderLinkTab": stakeholderLinkTab,
                        "clientFieldsSummary": clientFieldsSummary,
                        "projectFieldsSummary": projectFieldsSummary,
                        "clientFieldsNew": clientFieldsNew,
                        "projectFieldsNew": projectFieldsNew,
                        "commonFields": commonFields,
                        "clientAssociatedStakeholderFrame": clientAssociatedStakeholderFrame
                    }} />
            },
            {
                label: clientACTab,
                icon: 'pi pi-phone',
                Component: <Address
                    customerId={customerId}
                    clientId={clientId}
                    clientName={version}
                    branch={branch}
                    AddressContactData={{
                        "clientFieldsRDS": clientFieldsAC,
                        "clientSectionsSummary": clientSectionsAC,
                        "clientSummaryTab": clientACTab,
                        "clientFieldsNew": clientFieldsNew,
                        "commonFields": commonFields,
                        "addressContactFields": addressContactFields
                    }} />
            },
        ]

        var newItems = []
        if (tabPermissions["Summary"] && enableTabs["Summary"]) {
            newItems.push(tabs[0])
        }
        if (tabPermissions["Frameworks"] && enableTabs["Programmes"]) {
            newItems.push(tabs[1])
        }
        if (tabPermissions["Project"] && enableTabs["Project"]) {
            newItems.push(tabs[2])
        }
        if (tabPermissions["Relationship Development Score"] && enableTabs["ESG Preview Score"]) {
            newItems.push(tabs[3])
        }
        if (tabPermissions["Client Plan"] && enableTabs["Stakeholder Plan"]) {
            newItems.push(tabs[4])
        }
        if (tabPermissions["Link Stakeholders"] && enableTabs["Link Stakeholders"]) {
            newItems.push(tabs[5])
        }
        if (tabPermissions["Address and Contacts"] && enableTabs["Address and Contact"]) {
            newItems.push(tabs[6])
        }
        setLoading(false)

        setItems(newItems);
    }, [clientFieldsNew, customerDetails, tabPermissions]);

    useEffect(() => {
        if (branch) {
            cliData();
        }
    }, [clientId, branch])

    const cliData = async () => {
        if (clientId && customerId && branch) {
          setLoading(true); 
          try {
            const res = await get(clientId, customerId, branch);
      
            // Check if response data exists and contains the expected client data
            if (res.data && res.data.client && res.data.client.length > 0) {
              const cliData = res.data.client[0];
              setClientData(cliData);
              setRdsTotal(cliData?.rds.total);
            } else {
              toastRef.current.showToast({
                type: "error",
                message: "No client data found. Please check your input.",
              });
            }
          } catch (error) {
            // Handle errors during the API request
            toastRef.current.showToast({
              type: "error",
              message: "Failed to fetch client data. Please try again or contact Admin.",
            });
          } finally {
            setLoading(false); 
          }
        } 
      };
      

    const saveClient = async (label) => {
        setIsEdited(false);
        let data = clientData;
        if (rdsTotal) {
            data.rds.total = rdsTotal;
        }
        var reference_data = customerDetails?.data?.reference_data
        var option_choice = _.find(reference_data, { option_names: 'ClientClassificationV3' })?.option_choice
        clientData.selectedClientStatusIndex = option_choice?.findIndex(obj => obj.label === clientData.client_status)
        const CRDScoreBoxCRDScore = _.find(clientFieldsNew, { field_name: "Current Relationship Development Score" })?.display_name;

        // var ClientRDSLabel = CRDScoreBoxCRDScore.replace(/\&nbsp;/g, '');
        if (CRDScoreBoxCRDScore) {
            var CRDScoreBox = { "winScoreLabel": { "CRDScore": CRDScoreBoxCRDScore } }
            setLoading(true)
            const res = await saveCRDScoreBox(customerId, CRDScoreBox);
            setLoading(false)
        }

        var clientInCompleteActionIds = [];
        data.client_plan_section_new.map((element) => {
            element.strategic_initiative.forEach((item) => {
                if (item.isCompleted == false) {
                    clientInCompleteActionIds.push(item._id)
                }
            })
        })

        if (data.bid_team.status_update != "status update") {
            data.bid_team.status_update_logs.push({ 'updates': data.bid_team.status_update + '\n On: ' + new Date().toLocaleDateString('en-CA') });
            try {
                setLoading(true)
                const res = await update(data._id, data);
                setLoading(false)
                if (res && res.data.success === true) {
                    if (label != 'tab') {
                        toastRef.current.showToast({
                            type: 'success',
                            message: `${res.data.message}`
                        });
                    }
                    var notifyPending = await pendingCliNotifications(customerId, data._id)
                    if (notifyPending && notifyPending.data) {
                        cliData();
                        if (notifyPending.data.status) {
                            socket.emit('pushNotifications', customerId)
                        }
                    }
                    var reThrow = await reThrowNotification(clientInCompleteActionIds)
                    if (reThrow && reThrow.data) {
                        cliData();
                        if (reThrow.data.status) {
                            clientInCompleteActionIds = []
                            socket.emit('pushNotifications', customerId)
                        }
                    }
                }
                else {
                    if (label != 'tab') {
                        toastRef.current.showToast({
                            type: 'error',
                            message: `${res.data.message}`
                        });
                    }
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: "An error occurred. Please try again or contact Admin.",
                  });
            }
        } else {
            try {
                setLoading(true)
                const res = await update(data._id, data);
                setLoading(false)
                if (res && res.data.success === true) {
                    if (label != 'tab') {
                        toastRef.current.showToast({
                            type: 'success',
                            message: `${res.data.message}`
                        });
                    }
                    var notifyPending = await pendingCliNotifications(customerId, data._id)
                    if (notifyPending.data) {
                        cliData();
                        if (notifyPending.data.status) {
                            socket.emit('pushNotifications', customerId)
                        }
                    }
                    var reThrow = await reThrowNotification(clientInCompleteActionIds)
                    if (reThrow.data) {
                        cliData();
                        if (reThrow.data.status) {
                            clientInCompleteActionIds = []
                            socket.emit('pushNotifications', customerId)
                        }
                    }
                }
                else {
                    if (label != 'tab') {
                        toastRef.current.showToast({
                            type: 'error',
                            message: `${res.data.message}`
                        });
                    }
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: "An error occurred. Please try again or contact Admin.",
                  });
            }
        }
    }



    const getFieldData = async () => {
        setLoading(true)
        try {
            const response = await getField(customerId);
            if(response && response.data){
                const clientModuleData = response.data;
                if (clientModuleData) {
                    setLoading(true);
                    var clientModules = _.find(clientModuleData.cust[0].modules, { module_name: "Clients", status: true });
                    var projectModules = _.find(clientModuleData.cust[0].modules, { module_name: "Pipeline", status: true });
                    var frameworkModules = _.find(clientModuleData.cust[0].modules, { module_name: "Frameworks" }, true);
                    setFrameworkFieldsNew(_.find(frameworkModules.sub_modules, { sub_module_name: "NEW" }).fields);
                    setClientFieldsNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW" }).fields);
                    setClientSectionsNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW" }).sections);
                    setprojectFieldsNew(_.find(projectModules.sub_modules, { sub_module_name: "NEW" }).fields)
                    // Summary
                    setClientFieldsSummary(_.find(clientModules.sub_modules, { sub_module_name: "Summary" }).fields);
                    setclientSectionsSummary(_.find(clientModules.sub_modules, { sub_module_name: "Summary" }).sections);
                    setClientSummaryTab(_.find(clientModules.sub_modules, { sub_module_name: "Summary" }).display_name);
                    setprojectFieldsSummary(_.find(projectModules.sub_modules, { sub_module_name: "Summary" }).fields);
                    setFrameworkFieldsSummary(_.find(frameworkModules.sub_modules, { sub_module_name: "Summary" }).fields);
    
                    var commonModules = _.find(clientModuleData.cust[0].modules, { module_name: "Common Fields", status: true });
                    setCommonFields(_.find(commonModules.sub_modules, { sub_module_name: "Common Fields" }).fields);
    
                    // Frameworks
                    setClientFieldsFramework(_.find(clientModules.sub_modules, { sub_module_name: "Frameworks" }).fields);
                    setClientSectionsFramework(_.find(clientModules.sub_modules, { sub_module_name: "Frameworks" }).sections);
                    setClientFrameworkTab(_.find(clientModules.sub_modules, { sub_module_name: "Frameworks" }).display_name);
                    // Client Plan
                    setClientFieldsClientPlan(_.find(clientModules.sub_modules, { sub_module_name: "Client Plan" }).fields);
                    setClientSectionsClientPlan(_.find(clientModules.sub_modules, { sub_module_name: "Client Plan" }).sections);
                    setClientClientPlanTab(_.find(clientModules.sub_modules, { sub_module_name: "Client Plan" }).display_name);
                    // Project
                    setClientFieldsProject(_.find(clientModules.sub_modules, { sub_module_name: "Project" }).fields);
                    setClientSectionsProject(_.find(clientModules.sub_modules, { sub_module_name: "Project" }).sections);
                    setClientProjectTab(_.find(clientModules.sub_modules, { sub_module_name: "Project" }).display_name);
                    // Relationship Development Score
                    setClientFieldsRDS(_.find(clientModules.sub_modules, { sub_module_name: "Relationship Development Score" }).fields);
                    setClientSectionsRDS(_.find(clientModules.sub_modules, { sub_module_name: "Relationship Development Score" }).sections);
                    setClientRDSTab(_.find(clientModules.sub_modules, { sub_module_name: "Relationship Development Score" }).display_name);
                    // Address and Contact
                    setClientFieldsAC(_.find(clientModules.sub_modules, { sub_module_name: "Address and Contact" }).fields);
                    setClientSectionsAC(_.find(clientModules.sub_modules, { sub_module_name: "Address and Contact" }).sections);
                    setClientACTab(_.find(clientModules.sub_modules, { sub_module_name: "Address and Contact" }).display_name);
                    //Link Stakeholder
                    setClientFieldsLinkStakeholder(_.find(clientModules.sub_modules, { sub_module_name: "Link Stakeholders" }).fields);
                    setClientSectionsLinkStakeholder(_.find(clientModules.sub_modules, { sub_module_name: "Link Stakeholders" }).sections);
                    setStakeholderLinkTab(_.find(clientModules.sub_modules, { sub_module_name: "Link Stakeholders" })?.display_name);
                    //client plan module
    
                    var AddressContactModules = _.find(clientModuleData.cust[0].modules, { module_name: "Address Book" }, true);
                    setAddressContactFields(_.find(AddressContactModules.sub_modules, { sub_module_name: "Contacts" }).fields)
                    // setLoading(false)
    
                }
                setFieldData(response.data);
            }
           
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: "An error occurred. Please try again or contact Admin.",
              });
        } finally {
            setLoading(false)
        }
    };

    const getTableData = async () => {
        setLoading(true)
        try {
            const response = await getTable(customerId);
            // setLoading(false)
            if(response && response.data){
                const clientModuleData = response.data;
                if (clientModuleData) {
                    var clientModules = _.find(clientModuleData.cust[0].modules, { module_name: "Clients", status: true });
                    var clientFrameworkTable = _.find(clientModules?.sub_modules, { sub_module_name: "Framework" })?.tables;
                    setClientAssociatedFrame(clientFrameworkTable);
    
                    var clientLinkStakeholderTable = _.find(clientModules?.sub_modules, { sub_module_name: "Link Stakeholders" })?.tables;
                    setClientAssociatedStakeholderFrame(clientLinkStakeholderTable);
    
                    var clientPlanTable = _.find(clientModules.sub_modules, { sub_module_name: "Client Plan" })?.tables;
                    setClientKnownHeading(_.find(clientPlanTable, { table_name: "Known Client Initiatives" })?.display_name);
                    var clientHeaders = _.find(clientPlanTable, { table_name: "Known Client Initiatives" })?.headers;
                    setClientKnownHeaders(clientHeaders)
    
                    setClientPlanTable(clientPlanTable)
                    setClientNeedsHeading(_.find(clientPlanTable, { table_name: "Client Needs" })?.display_name);
    
                    setClientObjectivesHeading(_.find(clientPlanTable, { table_name: "Client Objectives" })?.display_name);
    
                    setClientDocumentHeading(_.find(clientPlanTable, { table_name: "Document Reference" })?.display_name);
                    // setLoading(false)
    
                }
                setTableData(response.data);
            }
            
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: "An error occurred. Please try again or contact Admin.",
              });
        } finally {
            setLoading(false)
        }
    };
    const updates = (e) => {
        setActiveIndex(e.index)
        // if (e?.value.label !== "Project") {
        saveClient('tab')
        // }
    }

    const setFavourite = () => {
        setClientData((prevState) => ({
            ...prevState,
            ['isFavourite']: !prevState.isFavourite,
        }));
    };

    const handleScrollClick = (event) => {
        event.preventDefault();
        scrollToTop();
    };

    useEffect(() => {
        if (!open) {
            if (items.length > 0) {
                var newItems = [];
                items.forEach((item) => {
                    var icons = {
                        icon: item.icon,
                        Component: item.Component,
                    };
                    newItems.push(icons);
                    setNewItems(newItems);
                });
            }
        }
    }, [open]);

    const toggleOpen = (data) => {
        setopen(data);
    };

    // For now, we will assume the content is part of the React component
    return (
        <>
            <div ref={targetRef} className="target-div" ></div>
            <div className="group-table-component stakeholder">
                <ButtonElement className="scroll-top save-button" title="Scroll to Top" icon="pi pi-arrow-up" onClick={handleScrollClick} />
                <ToastElement ref={toastRef} />
                <Loader loading={loading} />
                <div className="header-design">
                    <div>
                        <p className="fs-16 fw-600 mar-b-3">
                            {location.state?.clientName}
                            {
                                !clientData?.isFavourite ? (
                                    <InputIcon
                                        className="pi pi-star ml-10 pointer"
                                        onClick={setFavourite}
                                    />
                                ) : (
                                    <InputIcon
                                        className="pi pi-star-fill ml-10 pointer"
                                        onClick={setFavourite}
                                    />
                                )
                            }
                        </p>
                        <p className="group-table-text-section">
                            Use this section to edit stakeholder details
                        </p>
                    </div>
                    <div className='d-flex align-center justify-end '>
                        <ButtonElement className="save-button" type="submit" label="Save" onClick={() => saveClient('top')} />
                        <p className="fs-16 fw-600 mar-b-3 ml-20">{clientRDSTab}:</p>
                        <p className="fs-16 fw-600 mar-b-3 ml-20">{rdsTotal != undefined ? rdsTotal.toFixed(2) : 0}</p>
                    </div>
                </div>
                <div className={open ? "portfolio-tabs" : !globalSidebarData ? "portfolio-tabs collapse-tabs" : "portfolio-tabs collapse-tabs"}>
                    {
                        ((items != undefined && items.length > 0) || (newItems != undefined && newItems.length > 0)) &&
                        <TabElement
                            items={open ? items : newItems}
                            activeIndex={activeIndex}
                            onTabChange={(e) => updates(e)}
                            openTab={open}
                            setOpen={toggleOpen}
                            mainModules={true}
                        />
                    }
                </div>
                {/* <div>
                <TabMenuElement items={items} activeIndex={activeIndex} onTabChange={(e) => updates(e)} />
                </div>
                <div>
                {items && <div className='mt-10'>
                {items[activeIndex] && items[activeIndex].Component}
                </div>}
                </div> */}
            </div>
        </>
    );
};